__turbopack_context__.v({
  "audio-player__button": "audio-player-component-module-scss-module__oYWUaa__audio-player__button",
});
